import { isString, isNumber } from "@chakra-ui/utils";
import unit from "css-get-unit";

var startsWith = (string, target) => string.slice(0, 0 + target.length) == target;

export function positiveOrNegative(value, scale) {
  if (!scale || value == null) return value;
  var result;
  var valueString = value.toString();

  if (startsWith(valueString, "-")) {
    var raw = scale[valueString.slice(1)];

    if (isString(raw)) {
      result = "-" + raw;
    } else if (isNumber(raw)) {
      result = raw * -1;
    } else {
      result = value;
    }
  } else {
    var _scale$value;

    result = (_scale$value = scale[value]) != null ? _scale$value : value;
  }

  var computedValue = result || value;
  var hasUnit = unit(computedValue);

  if (!hasUnit && !isNaN(Number(computedValue))) {
    computedValue = Number(computedValue);
  }

  return computedValue;
}
//# sourceMappingURL=positive-or-negative.js.map